import { Component, Inject, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material';
import { ActivatedRoute } from '@angular/router';
import { ModelHelpers } from '../../../models/ModelHelpers';
import { PSCoordinacionProyectoModel } from '../../../models/ps-coordinacion-proyecto-model';
import { AuthService } from '../../../services/auth.service';
import { PsCoordinacionProyectoService } from '../../../services/ps-coordinacion-proyecto.service';
import { ToastrService } from 'ngx-toastr';
import { DateHelper } from '../../../models/NgDateCustomAdapter';

@Component({
  selector: 'app-ps-coordinacion-proyecto-edit',
  templateUrl: './ps-coordinacion-proyecto-edit.component.html',
  styleUrls: ['./ps-coordinacion-proyecto-edit.component.scss']
})
export class PsCoordinacionProyectoEditComponent implements OnInit {

  formGroup: FormGroup;
  model: any;
  title = 'Crear';
  isEdit: boolean;
  id: number;
  idps: number;
  isModal: boolean;
  errorMessage: string = "";

  constructor(private _fb: FormBuilder, private _avRoute: ActivatedRoute, @Inject(MAT_DIALOG_DATA) public data: any,
    private _psCoordinacionProyectoService: PsCoordinacionProyectoService, private _authService: AuthService,
    public dialogRef: MatDialogRef<PsCoordinacionProyectoEditComponent>, private _toastr: ToastrService,
    private dateHelper: DateHelper) {

    if (data) {
      this.id = data.id;
      this.idps = data.idps;
    }
  }

  ngOnInit() {
    this.buildForm();
    this.loadData();
  }

  buildForm() {
    this.formGroup = this._fb.group({
      id: 0,
      idps: [this.idps],
      descripcion: ['', Validators.required],
      fechaPrevistaHito: [null],
    });
  }

  loadData() {
    if (this.id > 0) {
      this.isEdit = true;
      this.title = 'Editar';
      this._psCoordinacionProyectoService.getById(this.id)
        .subscribe(resp => {
          this.model = resp;
          this.formGroup.setValue(resp);
        }, error => { console.error(error); });
    } else {
      this.isEdit = false;
      this.model = new PSCoordinacionProyectoModel();
      this.model.idps = this.idps;
      this.bindFromModel();
    }
  }

  bindFromModel() {
    this.formGroup.patchValue(this.model);
  }

  bindToModel() {
    ModelHelpers.copyFromForm(this.formGroup.value, this.model);
  }

  closeDialog() {
    this.dialogRef.close();
  }

  cancel() {
    this.closeDialog();
  }

  onSubmit() {
    this.errorMessage = "";
    

    if (!this.formGroup.valid) {
      console.error(this.formGroup.errors);
      this.errorMessage = 'Error de validación';
      this._toastr.error(this.errorMessage);
      return;
    }

    this.bindToModel();
    this.model.fechaPrevistaHito = this.dateHelper.dateFormat_iso(this.model.fechaPrevistaHito);

    if (!this.isEdit) {
      console.info('creando hito coordinación del proyecto');
      this._psCoordinacionProyectoService.post(this.model)
        .subscribe((data: any) => {
          if (data.correct === false) {
            this.errorMessage = data.mensaje;
            return;
          } else {
            this.dialogRef.close(true);
          }
        }, err => { this.errorMessage = err; }
        );
    } else {

      console.info('actualizando hito coordinación del proyecto con id:' + this.model.id);

      this._psCoordinacionProyectoService.put(this.id, this.model)
        .subscribe((data) => {
          if (data.correct === false) {
            this.errorMessage = data.mensaje;
            return;
          } else {
            this.dialogRef.close(true);
          }
        }, err => { this.errorMessage = err; }
        );
    }
  }

  get descripcion() { return this.formGroup.get('descripcion'); }
}
